<div class="inscripcion-bg" [class.tema-amuoetsylra]="esAmuoetsylra">
<div class="inscripcion-os-container">

    <!-- ===== HEADER ESTILO AUDITORIA ===== -->
    <div class="inscripcion-header">
      <div class="inscripcion-header__accent"></div>
      <div class="container inscripcion-header__inner">
        <span class="material-icons inscripcion-header__icon">assignment_ind</span>
        <div>
          <h1 class="inscripcion-header__title">Inscripción · <span>{{ esAmuoetsylra ? 'A.M.U.O.E.T.S.Y.L.R.A.' : 'U.O.E.T.S.Y.L.R.A.' }}</span></h1>
          <p class="inscripcion-header__subtitle">{{ esAmuoetsylra ? 'Matrícula INAES CF Nº 829' : 'Personería Gremial Nº 18' }}</p>
        </div>
      </div>
    </div>

    <div class="inscripcion-form-container">
      <form [formGroup]="inscripcionForm" (ngSubmit)="onSubmit()">

        <!-- ===== STEP BAR ===== -->
        <div class="step-bar">
          <ng-container *ngFor="let step of steps; let i = index">
            <div class="step"
                 [class.active]="currentStep === i + 1"
                 [class.completed]="maxStepReached > i + 1"
                 [class.error-step]="stepErrors[i]"
                 (click)="irAPaso(i + 1)">
              <div class="step-circle">
              <i *ngIf="maxStepReached > i + 1 && !stepErrors[i]" class="fas fa-check"></i>
                <span *ngIf="maxStepReached <= i + 1 || stepErrors[i]">{{ i + 1 }}</span>
              </div>
              <span class="step-label">{{ step }}</span>
            </div>
          </ng-container>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 1: DATOS DEL TITULAR -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 1" class="step-content">
          <div class="step-title">Datos del titular</div>

          <div formGroupName="datosDelTitular">

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Apellido</mat-label>
                <input matInput type="text" formControlName="apellido">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.apellido')?.hasError('required') && inscripcionForm.get('datosDelTitular.apellido')?.touched">
                  El apellido es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.apellido')?.hasError('pattern')">
                  Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input matInput type="text" formControlName="nombre">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nombre')?.hasError('required') && inscripcionForm.get('datosDelTitular.nombre')?.touched">
                  El nombre es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nombre')?.hasError('pattern')">
                  Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Tipo de Documento</mat-label>
                <mat-select formControlName="tipoDocumento">
                  <mat-option [value]="TipoDocumento.DNI">DNI</mat-option>
                  <mat-option [value]="TipoDocumento.CI">CI</mat-option>
                  <mat-option [value]="TipoDocumento.LE">LE</mat-option>
                  <mat-option [value]="TipoDocumento.LC">LC</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.tipoDocumento')?.hasError('required') && inscripcionForm.get('datosDelTitular.tipoDocumento')?.touched">
                  El tipo de documento es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Número de Documento</mat-label>
                <input matInput type="text" formControlName="numeroDocumento">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.numeroDocumento')?.hasError('required') && inscripcionForm.get('datosDelTitular.numeroDocumento')?.touched">
                  El número de documento es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.numeroDocumento')?.hasError('pattern')">
                  Solo números, máximo 10 dígitos
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>CUIL</mat-label>
                <input matInput placeholder="00-00000000-0" type="text" formControlName="cuil">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.cuil')?.hasError('required') && inscripcionForm.get('datosDelTitular.cuil')?.touched">
                  El CUIL es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.cuil')?.hasError('pattern')">
                  Solo números, máximo 12 dígitos
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Fecha de Nacimiento</mat-label>
                <input matInput [matDatepicker]="pickerTitular" formControlName="fechaNacimiento" appDirectivaFechas readonly (click)="pickerTitular.open()">
                <mat-datepicker-toggle matSuffix [for]="pickerTitular"></mat-datepicker-toggle>
                <mat-datepicker #pickerTitular></mat-datepicker>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.fechaNacimiento')?.hasError('required') && inscripcionForm.get('datosDelTitular.fechaNacimiento')?.touched">
                  La fecha de nacimiento es requerida
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Sexo</mat-label>
                <mat-select formControlName="sexo">
                  <mat-option [value]="Sexo.Masculino">Masculino</mat-option>
                  <mat-option [value]="Sexo.Femenino">Femenino</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.sexo')?.hasError('required') && inscripcionForm.get('datosDelTitular.sexo')?.touched">
                  El sexo es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Nacionalidad</mat-label>
                <input matInput type="text" formControlName="nacionalidad">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nacionalidad')?.hasError('required') && inscripcionForm.get('datosDelTitular.nacionalidad')?.touched">
                  La nacionalidad es requerida
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nacionalidad')?.hasError('pattern')">
                  Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Incapacitado</mat-label>
                <mat-select formControlName="incapacitado">
                  <mat-option [value]="true">Sí</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.incapacitado')?.hasError('required') && inscripcionForm.get('datosDelTitular.incapacitado')?.touched">
                  Este campo es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Estado Civil</mat-label>
                <mat-select formControlName="estadoCivil">
                  <mat-option [value]="EstadoCivil.Soltero">Soltero</mat-option>
                  <mat-option [value]="EstadoCivil.Casado">Casado</mat-option>
                  <mat-option [value]="EstadoCivil.Divorciado">Divorciado</mat-option>
                  <mat-option [value]="EstadoCivil.Viudo">Viudo</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.estadoCivil')?.hasError('required') && inscripcionForm.get('datosDelTitular.estadoCivil')?.touched">
                  El estado civil es requerido
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Domicilio del Titular -->
            <div class="step-subtitle">Domicilio</div>
            <div formGroupName="domicilio">
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Dirección</mat-label>
                  <input matInput type="text" formControlName="direccion">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.direccion')?.touched">
                    La dirección es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas y guiones. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input matInput type="text" formControlName="numero">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.numero')?.touched">
                    El número es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('pattern')">
                    Solo números y letras. Máximo 10 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Piso</mat-label>
                  <input matInput type="text" formControlName="piso">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.piso')?.hasError('pattern')">
                    Solo números, letras y guión. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Departamento</mat-label>
                  <input matInput type="text" formControlName="departamento">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.departamento')?.hasError('pattern')">
                    Solo números y letras. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Localidad</mat-label>
                  <input matInput type="text" formControlName="localidad">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.localidad')?.touched">
                    La localidad es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Provincia</mat-label>
                  <input matInput type="text" formControlName="provincia">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.provincia')?.touched">
                    La provincia es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Código Postal</mat-label>
                  <input matInput type="text" formControlName="codigoPostal">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.touched">
                    El código postal es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('pattern')">
                    Solo números y letras. Máximo 8 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 2: CONTACTO Y DOMICILIO -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 2" class="step-content">
          <div class="step-title">Contacto y domicilio</div>

          <div formGroupName="datosDelTitular">
            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input matInput type="text" formControlName="telefono">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.telefono')?.hasError('required') && inscripcionForm.get('datosDelTitular.telefono')?.touched">
                  El teléfono es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.telefono')?.hasError('pattern')">
                  Solo números, máximo 15 dígitos
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Celular</mat-label>
                <input matInput type="text" formControlName="celular">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.celular')?.hasError('required') && inscripcionForm.get('datosDelTitular.celular')?.touched">
                  El celular es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.celular')?.hasError('pattern')">
                  Solo números, máximo 15 dígitos
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.email')?.hasError('required') && inscripcionForm.get('datosDelTitular.email')?.touched">
                  El email es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.email')?.hasError('pattern')">
                  Formato de email inválido. Debe contener @ y un dominio válido.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="step-subtitle">Domicilio</div>
            <div formGroupName="domicilio">
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Dirección</mat-label>
                  <input matInput type="text" formControlName="direccion">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.direccion')?.touched">
                    La dirección es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas y guiones. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input matInput type="text" formControlName="numero">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.numero')?.touched">
                    El número es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('pattern')">
                    Solo números y letras. Máximo 10 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Piso</mat-label>
                  <input matInput type="text" formControlName="piso">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.piso')?.hasError('pattern')">
                    Solo números, letras y guión. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Departamento</mat-label>
                  <input matInput type="text" formControlName="departamento">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.departamento')?.hasError('pattern')">
                    Solo números y letras. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Localidad</mat-label>
                  <input matInput type="text" formControlName="localidad">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.localidad')?.touched">
                    La localidad es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Provincia</mat-label>
                  <input matInput type="text" formControlName="provincia">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.provincia')?.touched">
                    La provincia es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Código Postal</mat-label>
                  <input matInput type="text" formControlName="codigoPostal">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.touched">
                    El código postal es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('pattern')">
                    Solo números y letras. Máximo 8 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 3: DATOS LABORALES -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 3" class="step-content">
          <div class="step-title">Régimen laboral</div>

          <div formGroupName="datosDelTitular">
            <div class="regimenes-laborales">
              <mat-radio-group formControlName="regimenLaboral">
                <div class="opcion-regimen">
                  <mat-radio-button [value]="RegimenLaboral.General">Relación de Dependencia</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>

            <div class="regimen-error" *ngIf="inscripcionForm.get('datosDelTitular.regimenLaboral')?.hasError('required') && inscripcionForm.get('datosDelTitular.regimenLaboral')?.touched">
              Debe seleccionar un régimen laboral para continuar.
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Fecha de ingreso a la empresa</mat-label>
                <input matInput [matDatepicker]="pickerIngreso" formControlName="fechaIngresoEmpresa" appDirectivaFechas readonly (click)="pickerIngreso.open()">
                <mat-datepicker-toggle matSuffix [for]="pickerIngreso"></mat-datepicker-toggle>
                <mat-datepicker #pickerIngreso></mat-datepicker>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.hasError('required') && inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.touched">
                  La fecha de ingreso es requerida
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Datos de la Empresa -->
          <div *ngIf="showEmpresaSection" class="step-subsection">
            <div class="step-subtitle">Datos de la empresa o empleador</div>
            <div formGroupName="datosDeLaEmpresa">
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Razón social</mat-label>
                  <input matInput type="text" formControlName="razonSocial">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.touched">
                    La razón social es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas, & y guión. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>C.U.I.T</mat-label>
                  <input matInput type="text" formControlName="cuit">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.cuit')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.cuit')?.touched">
                    El CUIT es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.cuit')?.hasError('pattern')">
                    Solo números, máximo 11 dígitos
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Domicilio</mat-label>
                  <input matInput type="text" formControlName="domicilio">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.domicilio')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.domicilio')?.touched">
                    El domicilio es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.domicilio')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas y guiones. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Teléfono</mat-label>
                  <input matInput type="text" formControlName="telefono">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.telefono')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.telefono')?.touched">
                    El teléfono es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.telefono')?.hasError('pattern')">
                    Solo números, máximo 15 dígitos
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 4: GRUPO FAMILIAR -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 4" class="step-content">
          <div class="step-title">Grupo Familiar</div>

          <div formArrayName="familiares">
            <div class="familiares-list">
              <div class="familiar-card" *ngFor="let familiar of familiaresFormArray.controls; let i = index">
                <div class="familiar-card__info">
                  <span class="familiar-card__icon material-icons">person</span>
                  <div>
                    <strong>{{ familiar.get('nombre')?.value }} {{ familiar.get('apellido')?.value }}</strong>
                    <small>{{ familiar.get('parentesco')?.value === Parentesco.Hijo ? 'Hijo/a' : familiar.get('parentesco')?.value === Parentesco.Esposo ? 'Esposo/a' : 'Concubino/a' }}</small>
                  </div>
                </div>
                <div class="familiar-card__actions">
                  <button type="button" mat-icon-button color="primary" (click)="editFamiliar(i)" matTooltip="Editar familiar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button type="button" mat-icon-button color="warn" (click)="removeFamiliar(i)" matTooltip="Eliminar familiar">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="familiares-empty" *ngIf="familiaresFormArray.length === 0">
              <span class="material-icons" style="font-size:40px;color:var(--optionalColor);">group</span>
              <p>No hay familiares cargados. Puede agregarlos o continuar sin grupo familiar.</p>
            </div>
          </div>

          <div class="add-familiar-button">
            <button type="button" mat-stroked-button color="primary" (click)="addFamiliar()">
              <mat-icon>person_add</mat-icon> Agregar Familiar
            </button>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 5: DOCUMENTACIÓN -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 5" class="step-content">
          <div class="step-title">Documentación</div>
          <p class="step-desc">Seleccione un archivo para cada documento requerido. Formatos: PDF, JPG, PNG (máx. 50 MB).</p>

          <div class="file-slots-grid">
            <div *ngFor="let slot of dniFileSlots; let i = index" class="file-slot" [class.filled]="slot.file" [class.error-slot]="slot.error || (stepErrors[4] && !slot.file)">
              <div class="file-slot__icon" *ngIf="!slot.preview?.isImage">
                <mat-icon *ngIf="slot.file">check_circle</mat-icon>
                <mat-icon *ngIf="!slot.file">upload_file</mat-icon>
              </div>
              <div class="file-slot__thumb" *ngIf="slot.preview?.isImage" (click)="openImageModal(slot.preview.url)">
                <img [src]="slot.preview.safeUrl" class="file-slot__img">
              </div>
              <div class="file-slot__info">
                <span class="file-slot__label">{{ slot.label }}</span>
                <span class="file-slot__desc">{{ slot.descripcion }}</span>
                <span class="file-slot__filename" *ngIf="slot.file">{{ slot.file.name }}</span>
                <span class="file-slot__error" *ngIf="slot.error">{{ slot.error }}</span>
              </div>
              <input type="file" #dniInput hidden (change)="onSlotFileSelected(i, 'dni', $event)" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif">
              <div class="file-slot__actions">
                <button type="button" class="btn-slot" (click)="dniInput.click()">
                  {{ slot.file ? 'Cambiar' : 'Seleccionar' }}
                </button>
                <button type="button" *ngIf="slot.file" class="btn-slot-remove" (click)="removeSlotFile(i, 'dni')" matTooltip="Eliminar">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="file-slots-grid" *ngIf="actividadFileSlots.length > 0">
            <div *ngFor="let slot of actividadFileSlots; let i = index" class="file-slot" [class.filled]="slot.file" [class.error-slot]="slot.error || (stepErrors[4] && !slot.file)">
              <div class="file-slot__icon" *ngIf="!slot.preview?.isImage">
                <mat-icon *ngIf="slot.file">check_circle</mat-icon>
                <mat-icon *ngIf="!slot.file">upload_file</mat-icon>
              </div>
              <div class="file-slot__thumb" *ngIf="slot.preview?.isImage" (click)="openImageModal(slot.preview.url)">
                <img [src]="slot.preview.safeUrl" class="file-slot__img">
              </div>
              <div class="file-slot__info">
                <span class="file-slot__label">{{ slot.label }}</span>
                <span class="file-slot__desc">{{ slot.descripcion }}</span>
                <span class="file-slot__filename" *ngIf="slot.file">{{ slot.file.name }}</span>
                <span class="file-slot__error" *ngIf="slot.error">{{ slot.error }}</span>
              </div>
              <input type="file" #actInput hidden (change)="onSlotFileSelected(i, 'actividad', $event)" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif">
              <div class="file-slot__actions">
                <button type="button" class="btn-slot" (click)="actInput.click()">
                  {{ slot.file ? 'Cambiar' : 'Seleccionar' }}
                </button>
                <button type="button" *ngIf="slot.file" class="btn-slot-remove" (click)="removeSlotFile(i, 'actividad')" matTooltip="Eliminar">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 6: DOCUMENTACIÓN FAMILIARES -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 6" class="step-content">
          <div class="step-title">Documentación del grupo familiar</div>
          <p class="step-desc">Frente y dorso del DNI de cada familiar agregado.</p>

          <ng-container *ngIf="familiaresFileSlots.length > 0; else noFamiliaresDocs">
            <div class="file-slots-grid">
              <div *ngFor="let slot of familiaresFileSlots; let i = index" class="file-slot" [class.filled]="slot.file" [class.error-slot]="slot.error || (stepErrors[5] && !slot.file)">
                <div class="file-slot__icon" *ngIf="!slot.preview?.isImage">
                  <mat-icon *ngIf="slot.file">check_circle</mat-icon>
                  <mat-icon *ngIf="!slot.file">upload_file</mat-icon>
                </div>
                <div class="file-slot__thumb" *ngIf="slot.preview?.isImage" (click)="openImageModal(slot.preview.url)">
                  <img [src]="slot.preview.safeUrl" class="file-slot__img">
                </div>
                <div class="file-slot__info">
                  <span class="file-slot__label">{{ slot.label }}</span>
                  <span class="file-slot__desc">{{ slot.descripcion }}</span>
                  <span class="file-slot__filename" *ngIf="slot.file">{{ slot.file.name }}</span>
                  <span class="file-slot__error" *ngIf="slot.error">{{ slot.error }}</span>
                </div>
                <input type="file" #famInput hidden (change)="onSlotFileSelected(i, 'familiares', $event)" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif">
                <div class="file-slot__actions">
                  <button type="button" class="btn-slot" (click)="famInput.click()">
                    {{ slot.file ? 'Cambiar' : 'Seleccionar' }}
                  </button>
                  <button type="button" *ngIf="slot.file" class="btn-slot-remove" (click)="removeSlotFile(i, 'familiares')" matTooltip="Eliminar">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noFamiliaresDocs>
            <div class="no-docs-msg">
              <span class="material-icons">check_circle</span>
              <p>No hay documentos requeridos para el grupo familiar cargado.</p>
            </div>
          </ng-template>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 7: REVISIÓN Y ENVÍO -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 7" class="step-content">
          <div class="step-title">Revisión y envío</div>
          <p class="step-desc">Verifique los datos antes de enviar la inscripción.</p>

          <div class="review-section">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">person</span> Datos del titular</h3>
            <div class="review-row"><span class="k">Nombre</span><span class="v">{{ inscripcionForm.get('datosDelTitular.nombre')?.value }} {{ inscripcionForm.get('datosDelTitular.apellido')?.value }}</span></div>
            <div class="review-row"><span class="k">Documento</span><span class="v">{{ inscripcionForm.get('datosDelTitular.tipoDocumento')?.value === 0 ? 'DNI' : 'Otro' }} {{ inscripcionForm.get('datosDelTitular.numeroDocumento')?.value }}</span></div>
            <div class="review-row"><span class="k">CUIL</span><span class="v">{{ inscripcionForm.get('datosDelTitular.cuil')?.value }}</span></div>
            <div class="review-row"><span class="k">Email</span><span class="v">{{ inscripcionForm.get('datosDelTitular.email')?.value }}</span></div>
            <div class="review-row"><span class="k">Teléfono</span><span class="v">{{ inscripcionForm.get('datosDelTitular.telefono')?.value }} / {{ inscripcionForm.get('datosDelTitular.celular')?.value }}</span></div>
            <div class="review-row"><span class="k">Domicilio</span><span class="v">{{ inscripcionForm.get('datosDelTitular.domicilio.direccion')?.value }} {{ inscripcionForm.get('datosDelTitular.domicilio.numero')?.value }}, {{ inscripcionForm.get('datosDelTitular.domicilio.localidad')?.value }}, {{ inscripcionForm.get('datosDelTitular.domicilio.provincia')?.value }}</span></div>
          </div>

          <div class="review-section">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">work</span> Datos laborales</h3>
            <div class="review-row"><span class="k">Régimen</span><span class="v">{{ getRegimenLaboralNombre() }}</span></div>
            <div class="review-row"><span class="k">Fecha ingreso</span><span class="v">{{ inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.value | date:'dd/MM/yyyy' }}</span></div>
            <ng-container *ngIf="showEmpresaSection">
              <div class="review-row"><span class="k">Empresa</span><span class="v">{{ inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.value }}</span></div>
              <div class="review-row"><span class="k">CUIT Empresa</span><span class="v">{{ inscripcionForm.get('datosDeLaEmpresa.cuit')?.value }}</span></div>
            </ng-container>
          </div>

          <div class="review-section" *ngIf="familiaresFormArray.length > 0">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">group</span> Grupo familiar</h3>
            <div class="review-row" *ngFor="let f of familiaresFormArray.controls; let i = index">
              <span class="k">{{ i + 1 }}</span>
              <span class="v">{{ f.get('nombre')?.value }} {{ f.get('apellido')?.value }} ({{ f.get('parentesco')?.value === Parentesco.Hijo ? 'Hijo/a' : f.get('parentesco')?.value === Parentesco.Esposo ? 'Esposo/a' : 'Concubino/a' }})</span>
            </div>
          </div>

          <div class="review-section">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">description</span> Documentos</h3>
            <div class="review-row"><span class="k">DNI</span><span class="v">{{ countFilledSlots(dniFileSlots) }} archivos</span></div>
            <div class="review-row" *ngIf="actividadFileSlots.length > 0"><span class="k">Recibo de sueldo</span><span class="v">{{ selectedActividadFiles.length }} archivos</span></div>
            <div class="review-row" *ngIf="familiaresFileSlots.length > 0"><span class="k">DNI familiares</span><span class="v">{{ selectedFamiliaresFiles.length }} archivos</span></div>
          </div>

          <div class="dev-simular-error" *ngIf="modoAdmin">
            <label>
              <input type="checkbox" [checked]="simularErrorSubidaAdmin" (change)="toggleSimularErrorSubida()">
              <span>DEV: simular error de subida (para probar la re-subida de archivos)</span>
            </label>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="submit" class="btn-next" [disabled]="flagRegistrando">Enviar inscripción</button>
          </div>
        </div>

      </form>

      <div class="contact-info">
        <small>
          <a href="https://maps.app.goo.gl/LyBuWxd1pVH1mDHN9" target="_blank" rel="noopener">Culpina 25/31</a> • C1406ENA • Ciudad Autónoma de Buenos Aires • República Argentina
          <br>
          Tel/Fax: 4612-2000 Líneas Rotativas • <a href="https://www.osoetsylra.org" target="_blank" rel="noopener">www.osoetsylra.org</a>
        </small>
      </div>
    </div>
  </div>

  <!-- ===== MODAL FAMILIAR ===== -->
  <div *ngIf="showFamiliarModal" class="familiar-modal-overlay">
    <div class="familiar-modal-content" (click)="$event.stopPropagation()">
      <h3>{{ editingFamiliarIndex === null ? 'Agregar Familiar' : 'Editar Familiar' }}</h3>
      <form [formGroup]="familiarForm" class="familiar-form-content">
        <div class="form-row no-padding">
          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" id="familiar-nombre">
            <mat-error *ngIf="familiarForm.get('nombre')?.hasError('required')">El nombre es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('nombre')?.hasError('pattern')">Solo letras, apóstrofes y espacios. Máximo 50 caracteres.</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Apellido</mat-label>
            <input matInput formControlName="apellido" id="familiar-apellido">
            <mat-error *ngIf="familiarForm.get('apellido')?.hasError('required')">El apellido es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('apellido')?.hasError('pattern')">Solo letras, apóstrofes y espacios. Máximo 50 caracteres.</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>DNI</mat-label>
            <input matInput formControlName="numeroDocumento" id="familiar-numeroDocumento">
            <mat-error *ngIf="familiarForm.get('numeroDocumento')?.hasError('required')">El número de documento es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('numeroDocumento')?.hasError('pattern')">Solo números, máximo 10 dígitos</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row no-padding">
          <mat-form-field appearance="outline">
            <mat-label>Parentesco</mat-label>
            <mat-select formControlName="parentesco" id="familiar-parentesco">
              <mat-option [value]="Parentesco.Esposo">Esposo/a</mat-option>
              <mat-option [value]="Parentesco.Concubino">Concubino/a</mat-option>
              <mat-option [value]="Parentesco.Hijo">Hijo/a</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('parentesco')?.hasError('required')">El parentesco es requerido</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Nacionalidad</mat-label>
            <mat-select formControlName="nacionalidad" id="familiar-nacionalidad">
              <mat-option [value]="Nacionalidad.Argentino">Argentino/a</mat-option>
              <mat-option [value]="Nacionalidad.Extranjero">Extranjero/a</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('nacionalidad')?.hasError('required')">La nacionalidad es requerida</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fecha de Nacimiento</mat-label>
            <input matInput [matDatepicker]="familiarFechaNacimientoPicker" formControlName="fechaNacimiento" id="familiar-fechaNacimiento" appDirectivaFechas readonly (click)="familiarFechaNacimientoPicker.open()">
            <mat-datepicker-toggle matSuffix [for]="familiarFechaNacimientoPicker"></mat-datepicker-toggle>
            <mat-datepicker #familiarFechaNacimientoPicker></mat-datepicker>
            <mat-error *ngIf="familiarForm.get('fechaNacimiento')?.hasError('required')">La fecha de nacimiento es requerida</mat-error>
            <mat-error *ngIf="familiarForm.get('fechaNacimiento')?.hasError('hijoMayorQueTitular')">La fecha de nacimiento del hijo no puede ser anterior o igual a la del titular.</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row no-padding">
          <mat-form-field appearance="outline">
            <mat-label>Incapacidad</mat-label>
            <mat-select formControlName="incapacidad" id="familiar-incapacidad">
              <mat-option [value]="true">Sí</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('incapacidad')?.hasError('required')">Este campo es requerido</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Sexo</mat-label>
            <mat-select formControlName="sexo" id="familiar-sexo">
              <mat-option [value]="Sexo.Masculino">Masculino</mat-option>
              <mat-option [value]="Sexo.Femenino">Femenino</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('sexo')?.hasError('required')">El sexo es requerido</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CUIL</mat-label>
            <input matInput formControlName="cuil" id="familiar-cuil">
            <mat-error *ngIf="familiarForm.get('cuil')?.hasError('required')">El CUIL es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('cuil')?.hasError('pattern')">Solo números, máximo 11 dígitos</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row no-padding" *ngIf="esMayorDeEdad()">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" id="familiar-email">
            <mat-error *ngIf="familiarForm.get('email')?.hasError('pattern')">Formato de email inválido.</mat-error>
          </mat-form-field>
        </div>
        <div class="modal-actions-fixed">
          <button type="button" mat-button (click)="closeFamiliarModal()">Cancelar</button>
          <button type="button" mat-raised-button color="primary" (click)="saveFamiliar()">Guardar</button>
        </div>
      </form>
    </div>
  </div>

  <!-- ===== MODAL IMAGEN ===== -->
  <div *ngIf="selectedImageForModal" class="image-modal-overlay" (click)="closeImageModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeImageModal()">
        <mat-icon>close</mat-icon>
      </button>
      <img [src]="sanitizeUrl(selectedImageForModal)" alt="Vista previa ampliada" class="modal-image">
    </div>
  </div>

  <!-- ===== MODAL RECOMENDACIÓN CELULARES ANTIGUOS ===== -->
  <app-pop-up-modal-custom
    [show]="showDeviceWarningModal"
    titulo="Recomendación para celulares antiguos"
    [mensaje]="mensajeDispositivoWarning"
    tipo="warning"
    textoBoton="Entendido"
    (confirmado)="showDeviceWarningModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL TAMAÑO DE ARCHIVO ===== -->
  <app-pop-up-modal-custom
    [show]="showFileSizeError"
    titulo="Archivo demasiado grande"
    mensaje="El archivo excede el tamaño máximo permitido de 50 MB."
    tipo="warning"
    (confirmado)="showFileSizeError = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL ARCHIVO DUPLICADO ===== -->
  <app-pop-up-modal-custom
    [show]="showArchivoDuplicadoModal"
    titulo="Archivo duplicado"
    [mensaje]="mensajeArchivoDuplicado"
    tipo="warning"
    (confirmado)="showArchivoDuplicadoModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL SUBIDA FALLIDA (reintentar / cambiar archivo desde la modal) ===== -->
  <app-pop-up-modal-custom
    [show]="showSubidaFallidaModal"
    titulo="No se pudieron subir los documentos"
    mensaje="Estos documentos no se subieron correctamente. Elegí el archivo nuevamente o reintentá la subida."
    tipo="error"
    textoBoton="Reintentar subida"
    textoBotonCancelar="Cancelar"
    (confirmado)="reintentarSubidasFallidas()"
    (cerrado)="showSubidaFallidaModal = false"
  >
    <div class="subida-fallida-lista">
      <div class="subida-fallida-item" *ngFor="let f of subidasFallidas">
        <div class="subida-fallida-item__info">
          <strong class="subida-fallida-item__label">{{ f.label }}</strong>
          <span class="subida-fallida-item__nombre">Archivo actual: {{ f.archivo }}</span>
        </div>
        <label class="subida-fallida-item__picker">
          <input #retryFile hidden type="file"
            accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif"
            (change)="onSlotFileSelected(f.slotIndex, f.tipo, $event)">
          <button type="button" class="btn-slot" (click)="retryFile.click()">Elegir otro archivo</button>
        </label>
      </div>
      <p class="subida-fallida-ayuda">Verificá que el archivo sea PDF, JPG, PNG o HEIC y de hasta 50 MB.</p>
    </div>
  </app-pop-up-modal-custom>

  <!-- ===== MODAL ERROR DE REGISTRO ===== -->
  <app-pop-up-modal-custom
    [show]="showRegistroErrorModal"
    titulo="No se pudo completar la inscripción"
    mensaje="Ocurrió un error inesperado durante el registro. Por favor, intentá nuevamente."
    tipo="error"
    (confirmado)="showRegistroErrorModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL CONFIRMACIÓN AFILIACIÓN ===== -->
  <app-pop-up-modal-custom
    [show]="showConfirmarAfiliacionModal"
    titulo="Confirmación de afiliación"
    mensaje="Al continuar, usted comenzará el proceso de afiliación a la obra social."
    tipo="info"
    textoBoton="Continuar"
    textoBotonCancelar="Cancelar"
    (confirmado)="procesarInscripcion()"
    (cerrado)="showConfirmarAfiliacionModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL INSCRIPCIÓN ENVIADA ===== -->
  <app-pop-up-modal-custom
    [show]="showInscripcionExitosaModal"
    titulo="Inscripción enviada"
    mensaje="Su inscripción ha sido enviada exitosamente. Su afiliación está siendo procesada."
    tipo="info"
    (confirmado)="irAHome()"
  ></app-pop-up-modal-custom>

  <!-- ===== SPINNER ===== -->
  <app-spinner
      [show]="isUploadingFile"
      [text]="'Procesando su inscripción, por favor espere'"
      [type]="'fullscreen'"
      [size]="'large'"
      [color]="esAmuoetsylra ? '#114331' : '#124e91'"
      [trackColor]="esAmuoetsylra ? '#2e8b63' : '#1c75bc'"
      [blurBackground]="true">
  </app-spinner>
</div>
